import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import moment from "moment";

const DuplicateCheckModal = ({ open, onClose, duplicateList, onSelectDuplicate }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon style={{ color: "#ff9800", fontSize: 28 }} />
          <Typography variant="h6">Phát hiện sách trùng lặp</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 16 }}>
          Hệ thống phát hiện các sách có tiêu đề tương tự. Vui lòng kiểm tra:
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Tiêu đề</strong>
                </TableCell>
                <TableCell>
                  <strong>ISBN</strong>
                </TableCell>
                <TableCell>
                  <strong>Ngày xuất bản</strong>
                </TableCell>
                <TableCell>
                  <strong>Thao tác</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicateList.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.monograph?.title || ""}</TableCell>
                  <TableCell>{item.monograph?.isbn || ""}</TableCell>
                  <TableCell>
                    {item.monograph?.publicationDate ? moment(item.monograph.publicationDate).format("DD/MM/YYYY") : ""}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="primary" size="small" onClick={() => onSelectDuplicate(item)}>
                      Chỉnh sửa
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default DuplicateCheckModal;

